import {showErrorNotification} from "../../global/notifications";

let _month;
let _year;
let _salespersonId;
let _company;

export default function (company, month, year, salespersonId) {
    _month = month;
    _year = year;
    _salespersonId = salespersonId;
    _company = company;
    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId
    }
    loadApprovals(data);
}

function loadApprovals(data) {
    $('.js-ssr-commissions-approvals, .js-ssr-commissions-branch-approvals').load('/Finance/Approvals', data, function () {
        closeModal('CommissionsReject');
        closeModal('GsmOverrideApproval');
        attachApprovalButtonEvent();
        attachRejectButtonEvent();
        $.event.trigger('on:PageUpdate');
    });
}

function attachApprovalButtonEvent() {
    $('[data-role=approve]').click(function () {
        approveCommissions();
    })
}

function attachRejectButtonEvent() {
    $('[data-role=reject]').click(function () {
        let $rejectionComment = $('.js-rejection-comment');
        $rejectionComment.removeClass('fieldValidationError');
        if ($rejectionComment.length && $rejectionComment.val() !== '') {
            rejectCommissions();
        } else {
            $rejectionComment.addClass('fieldValidationError');
            showErrorNotification('Comment is required')
        }
    })
}

function approveCommissions() {
    const $pin = $('[name^=pin_id_]');
    const role = $pin.attr('name').substring(7,);

    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId,
        role: role,
        pin: $pin.val()
    }

    if (role === 'salesperson_override') {
        let $comment = $('.js-approval-override-comment');
        data.salespersonOverrideComment = $comment.val();
        if ($comment.val() === '') {
            showErrorNotification('Comment is required for approval')
            return;
        }
    }

    loadApprovals(data);
}

function rejectCommissions() {
    let data = {
        month: _month,
        year: _year,
        company: _company,
        salespersonId: _salespersonId,
        RejectionComment: $('.js-rejection-comment').val(),
        role: "reject"
    }

    loadApprovals(data);
}

const closeModal = (id) => {
    let $modalWindow = $(`#${id}`);
    if ($modalWindow.length) {
        let k_modalWindow = $modalWindow.data('kendoWindow');
        if (k_modalWindow) {
            k_modalWindow.close();
        }
    }
}